import { init as initApm } from '@elastic/apm-rum';
import { env } from 'env';

const apm = initApm({
  serviceName: 'portal-v2',
  serverUrl: 'https://9d75bd6232ea4b16b5fbf6d579f6f217.apm.eastus.azure.elastic-cloud.com:443',
  environment: env.REACT_APP_ENV
});

export default apm;
